module.exports = __webpack_public_path__ + "img/Screen_Shot_2.0988e108.png";